import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ActiveSupplierQuoteFragmentDoc } from './ActiveSupplierQuote.generated'
import * as Types from './purchasePlus_graphql'

export const CalculateLivePremiumQuotesFragmentDoc = gql`
  fragment CalculateLivePremiumQuotes on Price {
    unitPrice
    ...ActiveSupplierQuote
  }
  ${ActiveSupplierQuoteFragmentDoc}
` as unknown as DocumentNode<Types.CalculateLivePremiumQuotesFragment, unknown>
